<template>
    <div class="progress">
        <div class="status-box" :style="`${backgroundColor?'background-color:' + backgroundColor:''}`">
            <p class="title">{{title}}</p>
            <div class="status">
                <p class="p"><span class="sp" :style="`width: ${value}%;`"></span></p>
                <p class="rate">{{value}}%</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "progresses",
        props: {
            backgroundColor: String,
            title: {
                type: String,
                default: '课件发布中'
            },
            value: [String,Number]
        }
    }
</script>

<style lang="scss" scoped>
    .progress{
        display: flex;
        position: fixed;
        left: 0px;
        top: 0px;
        width: 100vw;
        height: 100vh;
        justify-content: center;
        align-items: center;
        background-color: rgba(0,0,0,.2);
        z-index: 10001;

        .status-box{
            width:200px;
            height:70px;
            background:rgba(255,255,255,1);
            box-shadow:0px 4px 12px 0px rgba(0,0,0,0.15);
            border-radius:4px;
            display: flex;
            flex-direction: column;
            /*align-items: center;*/
            overflow: hidden;

            .title{
                width:100%;
                height:22px;
                font-size:14px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:22px;
                margin-top: 12px;
                text-align: center;
            }

            .status{
                margin-top: 4px;
                font-size:12px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:22px;
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-left: 18px;

                .p{
                    width:120px;
                    height:10px;
                    background:rgba(240,242,245,1);
                    border-radius:11px;
                    position: relative;

                    .sp{
                        position: absolute;
                        top: 0px;
                        top: 0px;
                        width:88px;
                        height:10px;
                        background:linear-gradient(180deg,rgba(255,188,40,1) 0%,rgba(255, 120, 56,1) 100%);
                        box-shadow:0px 2px 6px 0px rgba(134,75,0,0.02),0px 1px 6px 0px rgba(255,182,25,0.54);
                        border-radius:11px;
                        transition: width 1s linear;
                    }
                }
                .rate {
                    margin-left: 10px;
                }
            }
        }
    }
</style>
